import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-location-search-input',
  templateUrl: './location-search-input.component.html',
  styleUrls: [ ]
})

export class LocationSearchInputComponent {
  @ViewChild('destination') destinationRef: ElementRef;
}



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/location-search-input/location-search-input.component.ts